// Helper function with better error handling
// Flattens the employees hierarchy tree into a flat list for table display.
// `expandedEmployees` is a Set of infinityCodes whose children should be visible.
export const flattenHierarchy = (
  node,
  expandedEmployees,
  level = 0,
  result = [],
  visited = new Set(),
  parentExpanded = true
) => {
  if (!node) return result;

  if (visited.has(node.infinityCode)) {
    console.warn(`⚠️ Circular reference detected: ${node.infinityCode}`);
    return result;
  }

  visited.add(node.infinityCode);

  // ✅ أضف الـ node بس لو الـ parent مفتوح (أو هو root)
  if (parentExpanded) {
    result.push({
      ...node,
      level,
      isExpanded: expandedEmployees.has(node.infinityCode),
      hasChildren: node.children && node.children.length > 0,
    });
  }

  // ✅ أظهر children بس لو الـ node ده مفتوح
  const shouldShowChildren = expandedEmployees.has(node.infinityCode);

  if (shouldShowChildren && node.children && node.children.length > 0) {
    // NOTE: `visited` is shared and backtracked, NOT cloned per child.
    // Cloning it (`new Set(visited)`) allocated a fresh Set for every node,
    // costing O(nodes x depth) time and garbage on the browser's main thread
    // every time this ran. Removing the node after its subtree is done keeps
    // the same guarantee -- a code cannot repeat on one root-to-node path --
    // at O(1) per node.
    node.children.forEach(child => {
      flattenHierarchy(child, expandedEmployees, level + 1, result, visited, true);
    });
  }

  visited.delete(node.infinityCode);

  return result;
};
